import { CollectionDataModel } from '../interfaces'

export const content = (): CollectionDataModel => {
    return {
        statement: [
            {
                contentId: '01_STATEMENT_1',
                contentType: 'IntroStatement',
                contentTitle: `The Uluru Statement</br> From the Heart`,
                contentPicture: [
                    {
                        contentPictureClass: 'uluru-morning-whole-part',
                        contentPictureImageSource: 'Uluru_Morning-2-500x77.png',
                        contentPictureSource: [
                            {
                                sourceSet: 'Uluru_Morning-2-1500x230.png',
                                wDescriptors: '1500w',
                                mediaCondition: '(max-width: 992px) 1500px',
                            },
                            {
                                sourceSet: 'Uluru_Morning-2-2500x384.png',
                                wDescriptors: '2500w',
                                mediaCondition: '(max-width: 1400px) 2500px',
                            },
                            {
                                sourceSet: 'Uluru_Morning-2-3000x461.png',
                                wDescriptors: '3000w',
                                mediaCondition: '(max-width: 2500px) 3000px',
                            },
                        ],
                    },
                ],
                contentBackgroundColor: '#f7f6f3',
                contentHelpText: 'Scroll to explore The Statement',
            },
            {
                contentId: '01_STATEMENT_2',
                contentType: 'TextAtTheTopOfImage',
                contentText: `In May 2017, over 250 Aboriginal and Torres Strait Islander Delegates
                    from all points of the Southern Sky gathered in Mutitjulu in the shadow
                    of Uluru and put their signatures on a historic statement. The Uluru
                    Statement From The Heart addressed to the Australian people invited
                    the nation to create a better future via the proposal of key reforms…`,
                contentTextInnerAlignment: 'Center',
                contentPicture: [
                    {
                        contentPictureClass: 'delegates-statement',
                        contentPictureImageSource:
                            'delegates-statement-600x339.jpg',
                        contentPictureSource: [
                            {
                                sourceSet: 'delegates-statement-600x339.jpg',
                                wDescriptors: '1500w',
                                mediaCondition: '(max-width: 992px) 1500px',
                            },
                            {
                                sourceSet: 'delegates-statement-1200x677.jpg',
                                wDescriptors: '3000w',
                                mediaCondition: '(max-width: 2500px) 3000px',
                            },
                        ],
                        contentPictureImageAlternateText:
                            'Photo of 3 of people where the middle one is holding a certificate.',
                    },
                ],
                contensBackgroundIsStaggered: true,
                contentBackgroundStaggeredMask1Source: 'white_1_2880x1080.png',
                contentBackgroundStaggeredMask2Source: 'white_2_2880x1080.png',
                contentBackgroundStaggeredMask3Source: 'white_3_2880x1080.png',
                contentBackgroundImageSource: 'USFTH_Signatures_2880x1080.jpg',
            },
            {
                contentId: '01_STATEMENT_3_1',
                contentType: 'SplitTitleAndTextAndImage',
                contentTitle: 'Voice',
                contentTitleColor: '#ffffff',
                contentText: `Enshrining a First Nations Voice in the Australian Constitution.`,
                contentBackgroundColor: '#212121',
                contentTextInnerAlignment: 'Center',
                contentSecondTitle: 'Makarrata',
                contentSecondTitleColor: '#ffffff',
                contentSecondText: `The coming together after a struggle to supervise a process of
                    agreement-making between governments and First Nations and
                    truth-telling about our history.`,
                contentSecondBackgroundImageSource:
                    'High-DPI-Uluru-Statement-2500x1406.jpg',
                contentSecondBackgroundColor: '#c4392f',
            },
            {
                contentId: '01_STATEMENT_4',
                contentType: 'TextOnly',
                contentCanvasType: 'NightSky',
                contentTextColor: '#f7f6f3',
                contentText: `We, gathered at the 2017 National Constitutional Convention, coming from
                    all points of the southern sky, make this statement from the heart:`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_5',
                contentType: 'TextOnly',
                contentCanvasType: 'NightSky',
                contentTextColor: '#f7f6f3',
                contentText: `Our Aboriginal and Torres Strait Islander tribes were the first sovereign Nations
                    of the Australian continent and its adjacent islands, and possessed it under our
                    own laws and customs. This our ancestors did, according to the reckoning of our
                    culture, from the Creation, according to the common law from ‘time immemorial’,
                    and according to science more than 60,000 years ago.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_6',
                contentType: 'TextBesideImage',
                contentText: `This sovereignty is a spiritual notion:
                    the ancestral tie between the land, or
                    ‘mother nature’, and the Aboriginal and
                    Torres Strait Islander peoples who were
                    born therefrom, remain attached
                    thereto, and must one day return
                    thither to be united with our ancestors.
                    This link is the basis of the ownership
                    of the soil, or better, of sovereignty. It
                    has never been ceded or extinguished,
                    and co-exists with the sovereignty of
                    the Crown.`,
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentPicture: [
                    {
                        contentPictureClass: 'man-dancing',
                        contentPictureImageSource: 'asset-23-720x662.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a group of men performing a dance.',
                    },
                ],
                contentBackgroundColor: '#f7f6f3',
            },
            {
                contentId: '01_STATEMENT_7',
                contentType: 'TextOnly',
                contentCanvasType: 'NightWaves',
                contentTextColor: '#f7f6f3',
                contentText: `How could it be otherwise? That peoples possessed a land for sixty millennia and this
                    sacred link disappears from world history in merely the last two hundred years?`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_8',
                contentType: 'TextOnly',
                contentCanvasType: 'NightWaves',
                contentTextColor: '#f7f6f3',
                contentText: `With substantive constitutional change and structural reform, we believe this ancient
                    sovereignty can shine through as a fuller expression of Australia’s nationhood.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_9',
                contentType: 'TextBesideImage',
                contentText: `Proportionally, we are the most
                    incarcerated people on the planet. We
                    are not an innately criminal people.
                    Our children are aliened from their
                    families at unprecedented rates. This
                    cannot be because we have no love for
                    them. And our youth languish in
                    detention in obscene numbers. <b>They</b>
                    <b>should</b> <b>be</b> <b>our</b> <b>hope</b> <b>for</b> <b>the</b> <b>future.</b>`,
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Left',
                contentPicture: [
                    {
                        contentPictureClass: 'child-dancing',
                        contentPictureImageSource:
                            'Uluru_Climb_Close_Ceremony-9-720x715.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a child performing a dance with a group of people.',
                    },
                ],
                contentBackgroundColor: '#f7f6f3',
            },
            {
                contentId: '01_STATEMENT_10',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal last">These dimensions of our
                    crisis tell plainly the structural nature of our problem.</div>`,
                contentTextHighlight: `This is the torment of our powerlessness.`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_11',
                contentType: 'TextBesideImage',
                contentText: `We seek constitutional reforms to
                    empower our people and take a <i>rightful</i>
                    <i>place</i> in our own country. When we
                    have power over our destiny our
                    children will flourish. They will walk in
                    two worlds and their culture will be a
                    gift to their country. `,
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentPicture: [
                    {
                        contentPictureClass: 'children-in-the-car',
                        contentPictureImageSource: 'REF_6863-720x586.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a group of children playing inside an old vintage car.',
                    },
                ],
                contentBackgroundColor: '#f7f6f3',
            },
            {
                contentId: '01_STATEMENT_12',
                contentType: 'TextOnly',
                contentCanvasType: 'DayClouds',
                contentText:
                    'We call for the establishment of a First Nations Voice enshrined in the Constitution.',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_13',
                contentType: 'TextOnly',
                contentCanvasType: 'DayClouds',
                contentText: `Makarrata is the culmination of our agenda: <i>the</i> <i>coming</i> <i>together</i> <i>after</i> <i>a</i> <i>struggle.</i>  
                    It captures our aspirations for a fair and truthful relationship with the people of
                    Australia and a better future for our children based on justice and self-determination.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_14',
                contentType: 'TextOnly',
                contentCanvasType: 'DayClouds',
                contentText: `We seek a Makarrata Commission to supervise a process of agreement-making
                    between governments and First Nations and truth-telling about our history. `,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_15',
                contentType: 'SplitTitleAndTextAndImage',
                contentTitle: 'In 1967',
                contentTitleColor: '#ffffff',
                contentText: 'we were counted',
                contentBackgroundColor: '#212121',
                contentTextInnerAlignment: 'Center',
                contentSecondBackgroundImageSource:
                    'referendum1967-1000x1125.jpg',
            },
            {
                contentId: '01_STATEMENT_19',
                contentType: 'SplitTitleAndTextAndImage',
                contentTitle: 'In 2017',
                contentTitleColor: '#ffffff',
                contentText: 'we seek to be heard.',
                contentBackgroundColor: '#212121',
                contentTextInnerAlignment: 'Center',
                contentSecondBackgroundImageSource:
                    'Uluru_National_Convention_Group_Photo_2017-1-1000x1125.jpg',
            },
            {
                contentId: '01_STATEMENT_17',
                contentType: 'TextOnly',
                contentCanvasType: 'DayMountains',
                contentTextColor: '#f7f6f3',
                contentText: `We leave base camp and start our trek across this vast country.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_18',
                contentType: 'TextOnly',
                contentCanvasType: 'DayMountains',
                contentTextColor: '#f7f6f3',
                contentText: `We invite you to walk with us in a movement of the Australian people for a better future.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '01_STATEMENT_19',
                contentType: 'CallToAction',
                contentBackgroundImageSource: 'Uluru-Statement-1-2500x1667.jpg',
                contentBackgroundGrayscaleImageSource:
                    'bg_statement_grayscale.jpg',

                contentTitle: 'Take Action',
                contentText: `Help build a better future by sharing our message today.`,
                contentCallToActionText: 'Learn more',
                contentCallToActionHref: '/take-action/',
                contentBackgroundColor: '#212121',

                contentSecondTitle: 'The Dialogues',
                contentSecondText: `Learn about the dialogues that led to The Statement.`,
                contentSecondCallToActionText: 'Learn more',
                contentSecondCallToActionHref: '/the-dialogues/',
                contentSecondBackgroundColor: '#b2352c',

                contentThirdTitle: 'The Statement',
                contentThirdText: `Download The Statement from the Heart.`,
                contentThirdCallToActionText: 'Download',
                contentThirdCallToActionHref:
                    '/wp-content/uploads/2022/01/UluruStatementfromtheHeartPLAINTEXT.pdf',
                contentThirdBackgroundColor: '#f7f6f3',
            },
        ],
        ourStory: [
            {
                contentId: '03_D_OURSTORY_1',
                contentType: 'IntroOurStory',
                contentTitle: 'Our Story',
                contentTitleColor: '#f9e2cf',
                contentText: `‘The entire land and seascape is named and the</br> cultural memory of our people is written here.’</br>
                    </br>
                    This is Our Story…`,
                contentTextColor: '#f7f6f3',
                contentBackgroundColor: '#212121',
                contentPicture: [
                    {
                        contentPictureClass: 'background-video-mobile',
                        contentPictureImageSource:
                            'Uluru-Our-Story-Parallax-1080x1920-15sec.mp4',
                    },
                    {
                        contentPictureClass: 'background-video-desktop',
                        contentPictureImageSource:
                            'Uluru-Our-Story-Parallax-1920x1080-20sec.mp4',
                    },
                ],
                contentHelpText: 'Scroll to explore',
            },
            {
                contentId: '03_D_OURSTORY_2',
                contentType: 'TextOnly',
                contentTextColor: '#f7f6f3',
                contentText: `Our First Nations are extraordinarily diverse cultures, living in an astounding
                    array of environments, multi lingual across many hundreds of languages and
                    dialects. The continent was occupied by our people and the footprints of our
                    ancestors traversed the entire landscape. Our songlines covered vast distances,
                    uniting peoples in shared stories and religion. The entire land and seascape is
                    named, and the cultural memory of our old people is written there.</br>
                    </br>
                    This rich diversity of our origins was eventually ruptured by colonisation.
                    Violent  dispossession and the struggle to survive a relentless inhumanity has
                    marked our  common history. The First Nations Regional Dialogues on
                    constitutional reform bore witness to our shared stories. `,
                contentBackgroundColor: '#212121',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '03_D_OURSTORY_3',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal">All stories start</div>`,
                contentTextHighlight: `with our Law.`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
                contentNextChapter: {
                    contentNextChapterTitle: 'The Law',
                    contentNextChapterTitleColor: '#FFFFFF',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#FFFFFF',
                    contentNextChapterHref: '/our-story/the-law',
                    contentNextChapterHrefColor: '#FFFFFF',
                },
            },
        ],
        ourStoryTheLaw: [
            {
                contentId: '04_D_LAW_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#ffffff',
                contentTitle: 'The Law',
                contentText: `We have coexisted as First Nations on this land for at
                    least 60,000 years. Our sovereignty pre-existed the
                    Australian state and has survived it.`,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-02-the-law-496x700.png',
            },
            {
                contentId: '04_D_LAW_2',
                contentType: 'TextQuoteHighlight',
                contentTextHighlight: `We have never, ever ceded our sovereignty.`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '04_D_LAW_3',
                contentType: 'TextOnly',
                contentTextColor: '#212121',
                contentText: `The unfinished business of Australia’s nationhood includes
                    recognising the ancient jurisdictions of First Nations law.`,
                contentBackgroundColor: '#f7f6f3',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '04_D_LAW_4',
                contentType: 'TextOverImage',
                contentBackgroundColor: '#212121',
                contentText: `‘The connection between language,
                    the culture, the land and the
                    enduring nature of Aboriginal law
                    is fundamental to any consideration
                    of constitutional recognition’.`,
                contentTextColor: '#f7f6f3',
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Right',
                contentTextAuthorName: 'Ross River',
                contentTextAuthorNameColor: '#ee312f',
                contentPicture: [
                    {
                        contentPictureClass: 'child-dancing',
                        contentPictureImageSource:
                            'Uluru-Climb-Close-Ceremony-2019-4-600x401.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a child performing a dance with a group of people.',
                    },
                ],
            },
            {
                contentId: '04_D_LAW_5',
                contentType: 'TextOnly',
                contentCanvasType: 'DayMountains',
                contentTextColor: '#f7f6f3',
                contentText: `Every First Nation has its own word for The Law. Tjukurrpa is the Anangu
                    word for The Law. The Meriam people of Mer refer to Malo’s Law. With
                    substantive constitutional change and structural reform, we believe this surviving
                    and underlying First Nation sovereignty can more effectively and powerfully
                    shine through as a fuller expression of Australia’s nationhood. `,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '04_D_LAW_6',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal">The Law was violated</div>
                    <div class="normal">by the coming of the</div>
                    <div class="normal last">British to Australia.</div>`,
                contentTextHighlight: `This truth needs to be told.`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
                contentNextChapter: {
                    contentNextChapterTitle: 'Invasion',
                    contentNextChapterTitleColor: '#FFFFFF',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#FFFFFF',
                    contentNextChapterHref: '/our-story/invasion',
                    contentNextChapterHrefColor: '#FFFFFF',
                },
            },
        ],
        ourStoryInvasion: [
            {
                contentId: '05_D_INVASION_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#f7f6f3',
                contentTitle: 'Invasion',
                contentText: `Australia was not a settlement and it was not a discovery.
                    It was an invasion.`,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-03-invasion-629x700.png',
            },
            {
                contentId: '05_D_INVASION_2',
                contentType: 'TextOnly',
                contentCanvasType: 'NightWaves',
                contentTextColor: '#f7f6f3',
                contentText: `‘Cook did not discover us, because we saw him.
                    We were telling each other with smoke, yet in his
                    diary, he said “discovered”.’`,
                contentTextAuthorName: 'Torres Strait',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '05_D_INVASION_3',
                contentType: 'TextOverImage',
                contentBackgroundColor: '#212121',
                contentText: `‘Australia must acknowledge its history,
                    its true history. Not Captain Cook.
                    What happened all across Australia:
                    the massacres and the wars. If that were
                    taught in schools, we might have one
                    nation, where we are all together.’`,
                contentTextColor: '#f7f6f3',
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Right',
                contentTextAuthorName: 'Darwin',
                contentTextAuthorNameColor: '#ee312f',
                contentPicture: [
                    {
                        contentPictureClass: 'man-dancing',
                        contentPictureImageSource: 'Uluru-2017-16-600x401.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a group of men performing a dance.',
                    },
                ],
            },
            {
                contentId: '05_D_INVASION_4',
                contentType: 'TextOnly',
                contentBackgroundColor: '#f7f6f3',
                contentTextColor: '#212121',
                contentText: `The invasion that started at Botany Bay is the origin of the fundamental grievance
                    between the old and new Australians: that Australia was colonised without the consent
                    of its rightful owners. Now is an opportunity for the First Nations to tell the truth
                    about history in our own voices and from our own point of view. And for mainstream
                    Australians to hear those voices and to reconsider what they know and understand
                    about their nation’s history. This will be challenging, but the truth about invasion
                    needs to be told.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '05_D_INVASION_6',
                contentType: 'ImageAndTextQuote',
                contentBackgroundColor: '#f7f6f3',
                contentText: `‘In order
                    for meaningful change
                    to happen, Australian
                    society generally needs
                    to “work on itself”
                    and to know the truth
                    of its own history.’ `,
                contentTextColor: '#c4392f',
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentTextAuthorName: 'Brisbane',
                contentTextAuthorNameColor: '#212121',
                contentPicture: [
                    {
                        contentPictureClass: 'uluru-at-dawn',
                        contentPictureImageSource:
                            'Uluru_Climb_Close_Ceremony_2019-12-600x337.jpg',
                        contentPictureImageAlternateText:
                            'Photo of Uluru at dawn.',
                    },
                ],
            },
            {
                contentId: '05_D_INVASION_7',
                contentType: 'TextOnly',
                contentBackgroundColor: '#212121',
                contentTextColor: '#f7f6f3',
                contentText: `‘People repeatedly emphasised the need for truth and justice,
                    and for non-Aboriginal Australians to take responsibility
                    for that history and this legacy it has created: “Government
                    needs to be told the truth of how people got to there.
                    They need to admit to that and sort it out.”’ `,
                contentTextAuthorName: 'Melbourne',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Left',
            },
            {
                contentId: '05_D_INVASION_8',
                contentType: 'TextQuoteHighlight',
                contentTextHighlight: `Invasion was met with resistance.`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
                contentNextChapter: {
                    contentNextChapterTitle: 'Resistance',
                    contentNextChapterTitleColor: '#FFFFFF',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#FFFFFF',
                    contentNextChapterHref: '/our-story/resistance',
                    contentNextChapterHrefColor: '#FFFFFF',
                },
            },
        ],
        ourStoryResistance: [
            {
                contentId: '06_D_RESISTANCE_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#f7f6f3',
                contentTitle: 'Resistance',
                contentText: `This is the time of the Frontier Wars, when massacres, disease
                    and poison decimated First Nations, even as they fought a
                    guerrilla war of resistance. The Tasmanian Genocide and the
                    Black War waged by the colonists reveals the truth about this evil
                    time. We acknowledge the resistance of the remaining First
                    Nations people in Tasmania who survived the onslaught.`,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-04-resistance-577x700.png',
            },
            {
                contentId: '06_D_RESISTANCE_2',
                contentType: 'ImageAndTextQuote',
                contentBackgroundColor: '#f7f6f3',
                contentText: `‘A statement should
                    recognise “the fights
                    of our old people”.’`,
                contentTextColor: '#c4392f',
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentTextAuthorName: 'Hobart',
                contentTextAuthorNameColor: '#212121',
                contentPicture: [
                    {
                        contentPictureClass: 'elder',
                        contentPictureImageSource: 'Uluru_2017-8-600x337.jpg',
                        contentPictureImageAlternateText: 'Photo of an elder.',
                    },
                ],
            },
            {
                contentId: '06_D_RESISTANCE_4',
                contentType: 'TextOnly',
                contentTextColor: '#f7f6f3',
                contentText: `Everywhere across Australia, great warriors like Pemulwuy and Jandamarra
                    led resistance against the British. First Nations refused to acquiesce to
                    dispossession and fought for their sovereign rights and their land. `,
                contentBackgroundColor: '#212121',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '06_D_RESISTANCE_5',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal last">The people who worked as
                    stockmen for no pay, who
                    have survived a history full
                    of massacres and pain.</div>`,
                contentTextHighlight: `We deserve respect.`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '06_D_RESISTANCE_6',
                contentType: 'Timeline',
                contentBackgroundColor: '#f7f6f3',
                contentText: `The Crown had made promises when it
                    colonised Australia. In 1768, Captain Cook
                    was instructed to take possession ‘with the
                    consent of the natives’. In 1787, Governor
                    Phillip was instructed to treat the First
                    Nations with ‘amity and kindness’. But
                    there was a lack of good faith. The Frontier
                    continued to move outwards and the
                    promises were broken in the refusal to
                    negotiate and the violence of colonisation.`,
                contentTextColor: '#212121',
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentPicture: [
                    {
                        contentPictureImageSource: 'Pimbloy-780x531.jpg',
                        contentPictureImageAlternateText:
                            'Engraving by Samuel John Neele of James Grant’s image of ‘Pimbloy’, believed to be the only known depiction of Pemulwuy.',
                    },
                ],
            },
            {
                contentId: '06_D_RESISTANCE_7',
                contentType: 'TextOverImage',
                contentBackgroundColor: '#212121',
                contentText: `Our people fought for and  won the 1967 Referendum, the most successful Yes vote  in Australian history.`,
                contentTextColor: '#f7f6f3',
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Right',

                contentTextAuthorNameColor: '#ee312f',
                contentPicture: [
                    {
                        contentPictureClass: 'elder-man',
                        contentPictureImageSource:
                            'Yarrabah-Uncle-Alfie-2-600x401.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a elder man.',
                    },
                ],
            },
            {
                contentId: '06_D_RESISTANCE_8',
                contentType: 'TextOnly',
                contentBackgroundColor: '#212121',
                contentTextColor: '#f7f6f3',
                contentText: `‘Participants expressed disgust about a statue of John
                    McDouall Stuart being erected in Alice Springs following
                    the 150th anniversary of his successful attempt to reach
                    the top end. This expedition led to the opening up of the
                    “South Australian frontier” which led to massacres as the
                    telegraph line was established and white settlers moved
                    into the region. People feel sad whenever they see the
                    statue; its presence and the fact that Stuart is holding
                    a gun is disrespectful to the Aboriginal community who
                    are descendants of the families slaughtered during the
                    massacres throughout central Australia.’`,
                contentTextAuthorName: 'Ross River',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Left',
                contentNextChapter: {
                    contentNextChapterTitle: 'Mourning',
                    contentNextChapterTitleColor: '#FFFFFF',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#FFFFFF',
                    contentNextChapterHref: '/our-story/mourning',
                    contentNextChapterHrefColor: '#FFFFFF',
                },
            },
        ],
        ourStoryMourning: [
            {
                contentId: '07_D_MOURNING_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#f7f6f3',
                contentTitle: 'Mourning',
                contentText: `Eventually the Frontier Wars came to an end. As the violence
                    subsided, governments employed new policies of control and
                    discrimination. We were herded to missions and reserves on
                    the fringes of white society. Our Stolen Generations were
                    taken from their families.`,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-05-mourning-670x700.png',
            },
            {
                contentId: '07_D_MOURNING_2',
                contentType: 'TextOnly',
                contentBackgroundColor: '#212121',
                contentTextColor: '#f7f6f3',
                contentText: `‘The Stolen Generations represented an example of
                    the many and continued attempts to assimilate people
                    and breed Aboriginality out of people, after the era of
                    frontier killing was over.’`,
                contentTextAuthorName: 'Melbourne',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Left',
            },
            {
                contentId: '07_D_MOURNING_3',
                contentType: 'TextOnly',
                contentCanvasType: 'NightRain',
                contentTextColor: '#f7f6f3',
                contentText: `But First Nations also re-gathered themselves. We remember the early heroes of our
                    movement such as William Cooper, Fred Maynard, Margaret Tucker, Pearl Gibbs, Jack
                    Patten and Doug Nicholls, who organised to deal with new realities. The Annual Day of
                    Mourning was declared on 26 January 1938. It reflected on the pain and injustice of
                    colonisation, and the necessity of continued resistance in defence of First Nations.
                    There is much to mourn: the loss of land, the loss of culture and language, the loss of
                    leaders who led our struggle in generations past.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '07_D_MOURNING_4',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal">‘A statement should recognise</div>`,
                contentTextHighlight: `“the fights of our old people”.’`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
                contentTextAuthorName: 'Hobart',
            },
            {
                contentId: '07_D_MOURNING_5',
                contentType: 'TextOverImage',
                contentBackgroundColor: '#212121',
                contentText: `‘Delegates spoke of the spiritual and
                    cultural things that have been stolen.
                    Delegates spoke of the destruction of
                    boundaries because of the forced
                    movement of people, the loss of First
                    Peoples and Sovereign First Nations
                    spirituality, and the destruction of
                    language.’ `,
                contentTextColor: '#f7f6f3',
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Right',
                contentTextAuthorName: 'Dubbo',
                contentTextAuthorNameColor: '#ee312f',
                contentPicture: [
                    {
                        contentPictureClass: 'elder-man',
                        contentPictureImageSource:
                            'Darwin-Dialogue-2017-57-600x401.jpg',
                        contentPictureImageAlternateText:
                            'Photo of a elder man.',
                    },
                ],
            },
            {
                contentId: '07_D_MOURNING_6',
                contentType: 'TextOnly',
                contentBackgroundColor: '#212121',
                contentTextColor: '#f7f6f3',
                contentText: `‘The burning of Mapoon in 1963 was remembered: “Mapoon
                    people have remained strong, we are still living at Mapoon.
                    Mapoon still exists in western Cape York but a lot of
                    our grandfathers have died at New Mapoon. That isn’t where
                    their spirits need to be.”’`,
                contentTextAuthorName: 'Cairns',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Left',
            },
            {
                contentId: '07_D_MOURNING_7',
                contentType: 'TextOnly',
                contentCanvasType: 'NightRain',
                contentTextColor: '#f7f6f3',
                contentText: `But as we mourn, we can also celebrate those who have gone before us. In a hostile
                    Australia, with discrimination and persecution, out of their mourning they started a
                    movement – the modern movement for rights, equality and self-determination.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '07_D_MOURNING_9',
                contentType: 'ImageAndTextQuote',
                contentBackgroundColor: '#f7f6f3',
                contentText: `We have learnt through
                    the leaders of the
                    Pilbara Strike, we have
                    learnt from the stories
                    of our big sisters, our
                    mothers, how to be
                    proud of who we are.’`,
                contentTextColor: '#c4392f',
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentTextAuthorName: 'Perth',
                contentTextAuthorNameColor: '#212121',
                contentPicture: [
                    {
                        contentPictureClass: 'elder-sitting-down',
                        contentPictureImageSource: 'Uluru_2017-13-600x337.jpg',
                        contentPictureImageAlternateText:
                            'Photo of elders sitting down.',
                    },
                ],
            },
            {
                contentId: '07_D_MOURNING_10',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal">‘The old men and
                    women were carrying fire.</div>`,
                contentTextHighlight: `… Let’s get that fire up and running again.’`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
                contentTextAuthorName: 'Darwin',
                contentNextChapter: {
                    contentNextChapterTitle: 'Activism',
                    contentNextChapterTitleColor: '#FFFFFF',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#FFFFFF',
                    contentNextChapterHref: '/our-story/activism',
                    contentNextChapterHrefColor: '#FFFFFF',
                },
            },
        ],
        ourStoryActivism: [
            {
                contentId: '08_D_ACTIVISM_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#f7f6f3',
                contentTitle: 'Activism',
                contentText: `The movement for political change continued to grow through the
                    20th Century. Confronted by discrimination and the oppressive
                    actions of government, First Nations showed tenacity, courage
                    and perseverance.`,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-06-activism-877x700.png',
            },
            {
                contentId: '08_D_ACTIVISM_2',
                contentType: 'TextQuoteHighlight',
                contentText: `<div class="normal last">‘Those who came before
                    us marched and died for
                    us and now it’s time to
                    achieve what we’ve been
                    fighting for since invasion: </div>`,
                contentTextHighlight: `self-determination.’`,
                contentHighlight1ImageSource: 'hl_1.png',
                contentHighlight2ImageSource: 'hl_2.png',
                contentHighlight3ImageSource: 'hl_3.png',
                contentHighlight4ImageSource: 'hl_4.png',
                contentHighlight5ImageSource: 'hl_5.png',
                contentHighlight6ImageSource: 'hl_6.png',
                contentBackgroundColorFade: 'true',
                contentTextInnerAlignment: 'Center',
                contentTextAuthorName: 'Adelaide',
            },
            {
                contentId: '08_D_ACTIVISM_3',
                contentType: 'TextOverImage',
                contentBackgroundColor: '#212121',
                contentText: `‘Torres Strait Islanders have a long
                    history of self-government. The civic
                    local government was established in
                    the late 1800s, and in the 1930s after
                    the maritime strikes, local councils
                    were created, and in the 1990s, the
                    TSRA. The Torres Strait Islander
                    peoples also have rights under the
                    Torres Strait Treaty.’ `,
                contentTextColor: '#f7f6f3',
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Right',
                contentTextAuthorName: 'Torres Strait',
                contentTextAuthorNameColor: '#ee312f',
                contentPicture: [
                    {
                        contentPictureClass: 'dr-davis',
                        contentPictureImageSource:
                            'Uluru-Photo-2017-9-600x401.jpg',
                        contentPictureImageAlternateText: 'Photo of Dr Davis.',
                    },
                ],
            },
            {
                contentId: '08_D_ACTIVISM_4',
                contentType: 'TextOnly',
                contentCanvasType: 'NightEmbers',
                contentTextColor: '#f7f6f3',
                contentText: `Our leaders knew that empowerment and positive change would only come from
                    activism. Right across Australia, First Nations took their fight to the government, the
                    people and the international community. From Yorta Yorta country, Yirrkala and many
                    other places, people sent petitions urging the King, the Prime Minister and the
                    Australian Parliament to heed their calls for justice. There were strikes for autonomy,
                    equality and land in the Torres Strait, the Pilbara and Palm Island.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '08_D_ACTIVISM_5',
                contentType: 'TextOnly',
                contentBackgroundColor: '#212121',
                contentTextColor: '#f7f6f3',
                contentText: `‘The history of petitions reminded people about the
                    nationally significant Palm Island Strike. So many people
                    from this region had been removed from Country to the
                    “penal settlement” of Palm Island since its establishment
                    in 1916. The Strike was also sparked by a petition, this time
                    from seven Aboriginal men demanding improved wages,
                    health, housing and working conditions, being ignored by
                    the superintendent. We commemorate 60 years of the
                    Strike in June 2017.’`,
                contentTextAuthorName: 'Cairns',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Left',
            },
            {
                contentId: '08_D_ACTIVISM_6',
                contentType: 'TextOnly',
                contentCanvasType: 'NightEmbers',
                contentTextColor: '#f7f6f3',
                contentText: `Our people fought for and won the 1967 Referendum, the most successful Yes
                    vote in Australian history. In front of the world, we set up an embassy on the
                    lawns of Parliament House and we marched in the streets of Brisbane during
                    the Commonwealth Games. In the west, grassroots leaders like the late Rob
                    Riley took the fight on sacred sites, deaths in custody and justice for the
                    Stolen Generations to the highest levels of government.`,
                contentTextInnerAlignment: 'Center',
                contentNextChapter: {
                    contentNextChapterTitle: 'Land Rights',
                    contentNextChapterTitleColor: '#FFFFFF',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#FFFFFF',
                    contentNextChapterHref: '/our-story/land-rights',
                    contentNextChapterHrefColor: '#FFFFFF',
                },
            },
        ],
        ourStoryLandRights: [
            {
                contentId: '09_D_LANDRIGHTS_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#f7f6f3',
                contentTitle: 'Land rights',
                contentText: `At the heart of our activism has been the long struggle for land
                    rights and recognition of native title. This struggle goes back to
                    the beginning. The taking of our land without consent represents
                    our fundamental grievance against the British Crown. `,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-07-landrights-1994x700.png',
            },
            {
                contentId: '09_D_LANDRIGHTS_2',
                contentType: 'TextOnly',
                contentCanvasType: 'DayMountains',
                contentTextColor: '#f7f6f3',
                contentText: `The struggle for land rights has united First Nations across the country, for example
                    Tent Embassy activists down south supported Traditional Owners in the Territory, who
                    fought for decades to retain control over their country. The Yolngu people’s fight
                    against mining leases at Yirrkala and the Gurindji walk-off from Wave Hill station were
                    at the centre of that battle. Their activism led to the Commonwealth legislating for
                    land rights in the Northern Territory. The epic struggle of Eddie Mabo and the Meriam
                    people resulted in an historic victory in 1992, when the High Court finally rejected the
                    legal fallacy of terra nullius and recognised that the land rights of First Nations peoples
                    survived the arrival of the British.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '09_D_LANDRIGHTS_3',
                contentType: 'PhotoGallery',
                contentBackgroundColor: '#f7f6f3',
                contentPicture: [
                    {
                        contentPictureClass: 'yirrkala',
                        contentPictureImageSource: '01-Yirrkala-300x324.jpg',
                        contentPictureImageAlternateText: 'Yirrkala',
                        contentPictureDescription: `Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Ut ac eros ut nisl
                            consectetur pretium sed viverra arcu. Pellentesque
                            egestas viverra purus, a suscipit libero ullamcorper id.
                            Ut nec dapibus lacus. Phasellus facilisis pulvinar leo 
                            sit amet bibendum.`,
                    },
                    {
                        contentPictureClass: 'the-10-point-plan-1938',
                        contentPictureImageSource:
                            '02-The_10_Point_Plan_1938-300x239.jpg',
                        contentPictureImageAlternateText:
                            'The 10 Point Plan 1938',
                        contentPictureDescription: `Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Ut ac eros ut nisl
                            consectetur pretium sed viverra arcu. Pellentesque
                            egestas viverra purus, a suscipit libero ullamcorper id.
                            Ut nec dapibus lacus. Phasellus facilisis pulvinar leo 
                            sit amet bibendum.`,
                    },
                    {
                        contentPictureClass: 'aboriginal-embassy',
                        contentPictureImageSource:
                            '03-Aboriginal_Embassy-300x390.jpg',
                        contentPictureImageAlternateText: 'Aboriginal Embassy',
                        contentPictureDescription: `Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Ut ac eros ut nisl
                            consectetur pretium sed viverra arcu. Pellentesque
                            egestas viverra purus, a suscipit libero ullamcorper id.
                            Ut nec dapibus lacus. Phasellus facilisis pulvinar leo 
                            sit amet bibendum.`,
                    },
                    {
                        contentPictureClass: 'paul-coe',
                        contentPictureImageSource:
                            '04-Photo_Paul_Coe-300x431.jpg',
                        contentPictureImageAlternateText: 'Paul Coe',
                        contentPictureDescription: `Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Ut ac eros ut nisl
                            consectetur pretium sed viverra arcu. Pellentesque
                            egestas viverra purus, a suscipit libero ullamcorper id.
                            Ut nec dapibus lacus. Phasellus facilisis pulvinar leo 
                            sit amet bibendum.`,
                    },
                    {
                        contentPictureClass: 'the-barunga-statement',
                        contentPictureImageSource:
                            '05-The_Barunga_Statement_Hawke_and_Galarrwuy_Yunupingu-300x314.jpg',
                        contentPictureImageAlternateText:
                            'The Barunga Statement Hawke and Galarrwuy Yunupingu',
                        contentPictureDescription: `Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Ut ac eros ut nisl
                            consectetur pretium sed viverra arcu. Pellentesque
                            egestas viverra purus, a suscipit libero ullamcorper id.
                            Ut nec dapibus lacus. Phasellus facilisis pulvinar leo 
                            sit amet bibendum.`,
                    },
                    {
                        contentPictureClass: 'gurindji-walk-off',
                        contentPictureImageSource:
                            '06-Photo_Gurindji_Walk_Off-300x246.jpg',
                        contentPictureImageAlternateText: 'Gurindji Walk Off',
                        contentPictureDescription: `Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Ut ac eros ut nisl
                            consectetur pretium sed viverra arcu. Pellentesque
                            egestas viverra purus, a suscipit libero ullamcorper id.
                            Ut nec dapibus lacus. Phasellus facilisis pulvinar leo 
                            sit amet bibendum.`,
                    },
                    {
                        contentPictureClass: 'mabo-decision',
                        contentPictureImageSource: '07-Mabo-600x368.jpg',
                        contentPictureImageAlternateText: 'Mabo decision',
                        contentPictureDescription: `The epic struggle of Eddie Mabo
                            and the Merium People resulted
                            in a historic victory in 1992 when
                            the High Court of Australia finally
                            rejected the legal fallacy of ‘Terra
                            Nullius’ and recognised the Land
                            Rights of First Nations succeeding
                            the arrival of the British.`,
                    },
                ],
                contentNextChapter: {
                    contentNextChapterTitle: 'Makarrata',
                    contentNextChapterTitleColor: '#000000',
                    contentNextChapterSubTitle: 'Our Story',
                    contentNextChapterSubTitleColor: '#000000',
                    contentNextChapterHref: '/our-story/makarrata',
                    contentNextChapterHrefColor: '#000000',
                },
            },
        ],
        ourStoryMakarrata: [
            {
                contentId: '10_D_MAKARRATA_1',
                contentType: 'TitleTextAndFeatureImage',
                contentBackgroundColor: '#f7f6f3',
                contentTitle: 'Makarrata',
                contentText: `The invasion of our land was met by resistance. But colonisation
                    and dispossession cut deeply into our societies, and we have
                    mourned the ancestors who died in the resistance, and the loss of
                    land, language and culture. Through the activism of our leaders
                    we have achieved some hard-won gains and recovered control
                    over some of our lands. After the Mabo case, the Australian legal
                    system can no longer hide behind the legal fiction of terra
                    nullius. But there is Unfinished Business to resolve. And the way
                    to address these differences is through agreement-making.`,
                contentTextInnerAlignment: 'Center',
                contentBackgroundImageSource:
                    'chapter-title-08-makarrata-540x700.png',
            },
            {
                contentId: '10_D_MAKARRATA_2',
                contentType: 'TextOnly',
                contentCanvasType: 'DayClouds',
                contentText: `Makarrata is another word for Treaty or agreement-making. It is the culmination of our
                    agenda. It captures our aspirations for a fair and honest relationship with government
                    and a better future for our children based on justice and self-determination. `,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '10_D_MAKARRATA_3',
                contentType: 'TextOverImage',
                contentBackgroundColor: '#212121',
                contentText: `‘If the community can’t self-determine
                    and make decisions for our own
                    community regarding economic and
                    social development, then we can’t be
                    confident about the future for our
                    children.’`,
                contentTextColor: '#f7f6f3',
                contentTextPosition: 'Left',
                contentTextInnerAlignment: 'Right',
                contentTextAuthorName: 'Wreck Bay',
                contentTextAuthorNameColor: '#ee312f',
                contentPicture: [
                    {
                        contentPictureClass: 'uluru-statement',
                        contentPictureImageSource: 'Uluru-2017-3-600x401.jpg',
                        contentPictureImageAlternateText:
                            'Photo group of people holding the Uluru Statement.',
                    },
                ],
            },
            {
                contentId: '10_D_MAKARRATA_4',
                contentType: 'TextOnly',
                contentCanvasType: 'DayClouds',
                contentText: `Through negotiated settlement, First Nations can build their cultural strength, reclaim
                    control and make practical changes over the things that matter in their daily life. By
                    making agreements at the highest level, the negotiation process with the Australian
                    government allows First Nations to express our sovereignty – the sovereignty that we
                    know comes from The Law.`,
                contentTextInnerAlignment: 'Center',
            },
            {
                contentId: '10_D_MAKARRATA_5',
                contentType: 'TextOnly',
                contentBackgroundColor: '#212121',
                contentTextColor: '#f7f6f3',
                contentText: ` ‘The group felt strongly that the Constitution needed to
                    recognise the traditional way of life for Aboriginal people. …
                    It would have to acknowledge the “Tjukurrpa” – “our own
                    Constitution”, which is what connects Aboriginal people to
                    their creation and gives them authority.’`,
                contentTextAuthorName: 'Ross River',
                contentTextAuthorNameColor: '#ee312f',
                contentTextInnerAlignment: 'Left',
            },
            {
                contentId: '10_D_MAKARRATA_7',
                contentType: 'ImageAndTextQuote',
                contentBackgroundColor: '#f7f6f3',
                contentText: `‘There is a potential
                    for two sovereignties
                    to co-exist in which both
                    western and Indigenous
                    values and identities are
                    protected and given voice
                    in policies and laws.’ `,
                contentTextColor: '#c4392f',
                contentTextPosition: 'Right',
                contentTextInnerAlignment: 'Left',
                contentTextAuthorName: 'Broome',
                contentTextAuthorNameColor: '#212121',
                contentPicture: [
                    {
                        contentPictureClass: 'uluru-at-dawn',
                        contentPictureImageSource:
                            'Uluru_Night_Photo_2017-1-600x337.jpg',
                        contentPictureImageAlternateText:
                            'Photo of Uluru at dawn.',
                    },
                ],
            },
            {
                contentId: '10_D_MAKARRATA_8',
                contentType: 'TakeAction',
                contentTitle: 'Take Action',
                contentText: `Become part of the movement to help
                    build a better future for all First Nations
                    and Australian people.`,
                contentTextInnerAlignment: 'Center',
                contentCallToActionText: 'Learn More',
                contentCallToActionHref: '/take-action',
            },
        ],
    }
}

export const getContent = () => {
    const isStatement = window.location.pathname.indexOf('the-statement') === 1

    const isOurStoryTheLaw =
        window.location.pathname.indexOf('our-story/the-law') === 1

    const isOurStoryInvasion =
        window.location.pathname.indexOf('our-story/invasion') === 1

    const isOurStoryResistance =
        window.location.pathname.indexOf('our-story/resistance') === 1

    const isOurStoryMourning =
        window.location.pathname.indexOf('our-story/mourning') === 1

    const isOurStoryActivism =
        window.location.pathname.indexOf('our-story/activism') === 1

    const isOurStoryLandRights =
        window.location.pathname.indexOf('our-story/land-rights') === 1

    const isOurStoryMakarrata =
        window.location.pathname.indexOf('our-story/makarrata') === 1

    const isOurStory =
        window.location.pathname.indexOf('our-story') === 1 &&
        !isOurStoryTheLaw &&
        !isOurStoryInvasion &&
        !isOurStoryResistance &&
        !isOurStoryMourning &&
        !isOurStoryActivism &&
        !isOurStoryLandRights &&
        !isOurStoryMakarrata

    if (isStatement) {
        return content().statement
    } else if (isOurStory) {
        return content().ourStory
    } else if (isOurStoryTheLaw) {
        return content().ourStoryTheLaw
    } else if (isOurStoryInvasion) {
        return content().ourStoryInvasion
    } else if (isOurStoryResistance) {
        return content().ourStoryResistance
    } else if (isOurStoryMourning) {
        return content().ourStoryMourning
    } else if (isOurStoryActivism) {
        return content().ourStoryActivism
    } else if (isOurStoryLandRights) {
        return content().ourStoryLandRights
    } else if (isOurStoryMakarrata) {
        return content().ourStoryMakarrata
    } else {
        return []
    }
}

export const getOurStoryLinks = () => {
    const ourStoryLinks = [
        {
            chapterName: 'Our Story',
            chapterUrl: '/our-story',
            chapterFrames: content().ourStory?.length,
        },
        {
            chapterName: 'The Law',
            chapterUrl: '/our-story/the-law',
            chapterFrames: content().ourStoryTheLaw?.length,
        },
        {
            chapterName: 'Invasion',
            chapterUrl: '/our-story/invasion',
            chapterFrames: content().ourStoryInvasion?.length,
        },
        {
            chapterName: 'Resistance',
            chapterUrl: '/our-story/resistance',
            chapterFrames: content().ourStoryResistance?.length,
        },
        {
            chapterName: 'Mourning',
            chapterUrl: '/our-story/mourning',
            chapterFrames: content().ourStoryMourning?.length,
        },
        {
            chapterName: 'Activism',
            chapterUrl: '/our-story/activism',
            chapterFrames: content().ourStoryActivism?.length,
        },
        {
            chapterName: 'Land Rights',
            chapterUrl: '/our-story/land-rights',
            chapterFrames: content().ourStoryLandRights?.length,
        },
        {
            chapterName: 'Makarrata',
            chapterUrl: '/our-story/makarrata',
            chapterFrames: content().ourStoryMakarrata?.length,
        },
    ]

    return ourStoryLinks
}
